module.exports = __webpack_public_path__ + "static/HelveticaNeueLTW1G-Lt-128e84d9cad3949be421b60fe0ecb954.woff";